export enum TICKET_STATE {
  OPEN = 1,
  REOPENED = 2,
  RESOLVED = 3,
  CLOSED = 4,
}

export const TicketStateString = {
  [TICKET_STATE.OPEN]: 'Abierto',
  [TICKET_STATE.REOPENED]: 'Reabierto',
  [TICKET_STATE.RESOLVED]: 'Resuelto',
  [TICKET_STATE.CLOSED]: 'Cerrado',
};

export enum TICKET_OPEN_STATE_FILTER {
  ALL = 0,
  OPEN = 1,
  CLOSED = -1,
}

export enum TICKET_PRIORITY {
  CRITICO = 1,
  ALTA = 2,
  NORMAL = 3,
  BAJA = 4,
  MUY_BAJA = 5,
}

export const TicketPriorityString = {
  [TICKET_PRIORITY.CRITICO]: 'Crítico',
  [TICKET_PRIORITY.ALTA]: 'Alta',
  [TICKET_PRIORITY.NORMAL]: 'Normal',
  [TICKET_PRIORITY.BAJA]: 'Baja',
  [TICKET_PRIORITY.MUY_BAJA]: 'Muy baja',
};

export enum TICKET_TYPE {
  REACTIVO = 1,
  PROACTIVO = 2,
}

export const TicketTypeString = {
  [TICKET_TYPE.REACTIVO]: 'Reactivo',
  [TICKET_TYPE.PROACTIVO]: 'Proactivo',
};

export enum TICKET_LOGISTIC_STATE {
  /**
   * No tiene paquetes asociados (ni envíos ni recepciones)
   */
  SIN_GESTION_LOGISTICA = 0,
  /**
   * Todos sus paquetes están en estado PENDIENTE
   */
  PENDIENTE = 1,
  /**
   * Al menos uno de sus paquetes está en un estado distinto a PENDIENTE
   */
  EN_CURSO = 2,
  /**
   * Todos sus paquetes están en estado FINALIZADO y todos los ITEM PAQUETES tienen asignada una resolución.
   * Este último caso debería contemplar que si la resolución es FACTURADO deba incluir el número de factura
   */
  LISTO_PARA_RESOLVER = 3,
  /**
   * Todos sus paquetes están en estado FINALIZADO pero al menos un ITEM PAQUETE no tiene asignada una resolución
   * o la resolución es FACTURADO pero no tiene número de factura asignado.
   */
  FINALIZADO = 4,
  CANCELADO = 5,
}

export const TicketLogisticStateString = {
  [TICKET_LOGISTIC_STATE.SIN_GESTION_LOGISTICA]: 'Sin gestión logística',
  [TICKET_LOGISTIC_STATE.PENDIENTE]: 'Pendiente',
  [TICKET_LOGISTIC_STATE.EN_CURSO]: 'En curso',
  [TICKET_LOGISTIC_STATE.LISTO_PARA_RESOLVER]: 'Listo para resolver',
  [TICKET_LOGISTIC_STATE.FINALIZADO]: 'Finalizado',
  [TICKET_LOGISTIC_STATE.CANCELADO]: 'Cancelado',
};
